@if (templateData(); as templateData) {
  <div
    [class]="templateData.breakpoint"
    class="sim-page-container"
    [class.toolbar-logo]="!templateData.toolbar?.navLinks"
  >
    <common-navbar class="navbar">
      @if (templateData.toolbar?.navLinks) {
        <button
          id="sidenav-open"
          sim-icon-button
          class="navbar__sidenav"
          (click)="sidenav && sidenav.hasBackdrop.set(false); sidenav && sidenav.sidenavLeft.toggle()"
        >
          <sim-icon icon="hamburger" color="#707070" sizeType="medium" area24 />
        </button>

        <div class="navbar__title">
          {{ templateData.toolbar?.headerTitle }}
        </div>

        <horizontal-scroll>
          <nav class="navbar__links">
            @for (nav of templateData.toolbar?.navLinks; let i = $index; track $index) {
              @if (nav.hasPrivilege === false && nav.disabledTooltip) {
                <sim-tooltip class="navbar__links__tooltip" [tooltip]="nav.disabledTooltip" [focusable]="false">
                  <ng-container *ngTemplateOutlet="navLink; context: { nav, i }" />
                </sim-tooltip>
              } @else {
                <ng-container *ngTemplateOutlet="navLink; context: { nav, i }" />
              }
            }
          </nav>
        </horizontal-scroll>
      } @else {
        <img class="logo" src="assets/images/logo/Logo_simon.svg" />
      }
      <layout-navbar-user />
    </common-navbar>
    <common-content class="content" [style]="templateData.hideBottomToolbar && { '--temp-toolbar-h': 0 }">
      <router-outlet />
    </common-content>
  </div>
}

<ng-template #navLink let-nav="nav" let-i="i">
  <a
    id="nav-bar-link-{{ i }}"
    sim-button
    [routerLink]="nav.path"
    routerLinkActive="active-link"
    [class.inactive-link]="activeRouterLink !== nav.name"
    (isActiveChange)="changeActiveRouterLink($event, nav.name)"
    [class.invisible-nav]="nav.isMobileInvisible"
    [class.disabled]="nav.hasPrivilege === false"
    [disabled]="nav.hasPrivilege === false"
    [attr.tabindex]="nav.hasPrivilege === false ? -1 : null"
    (click)="nav.hasPrivilege === false && $event.preventDefault()"
    ><span class="navbar__links__container"
      ><sim-icon
        [icon]="nav.icon || 'lights'"
        [sizeType]="templateData()?.breakpoint === 'tablet' ? 'small' : 'medium'"
        [area24]="templateData()?.breakpoint !== 'tablet'"
        color="var(--nav-icon-color)"
      ></sim-icon>
      <span [class.navbar__links__container--active]="activeRouterLink === nav.name" class="body_small_regular">{{
        nav.label
      }}</span></span
    >
  </a>
</ng-template>
